import { DA2UM_ONNA_API_DOMAIN, HIVE_ONNA_API_DOMAIN, LINC_ONNA_API_DOMAIN } from '@constants/api'; // Centralized mapping from vrtype to Onna API domain
export function getOnnaDomain(vrtype) {
    switch (vrtype) {
        case 'LINC': return LINC_ONNA_API_DOMAIN;
        case 'HIVE': return HIVE_ONNA_API_DOMAIN;
        case 'DA2UM': return DA2UM_ONNA_API_DOMAIN;
        default: // fallback to DA2UM if unknown
            return DA2UM_ONNA_API_DOMAIN;
    }
}
const domain = { getOnnaDomain };
export default domain;
